module.exports = __webpack_public_path__ + "defaultAvatar.114a0757.png";